import request from '@/request'
import * as Types from './types'

// 查询角色列表
export const queryRoleList = (params: {
  tenantId: string
}): Promise<ResponseData<Types.RoleListItem[]>> => {
  return request.post('/role/queryList', params)
}
// 分页查询角色列表
export const queryRolePageList = (params: {
  tenantId?: string | null
  tenantIds?: string[]
  pageNo: number
  pageSize: number
  roleName?: string
}): Promise<ResponseData<Types.QueryRolePageListResponseData>> => {
  return request.post('/role/queryRolePage', params)
}

// 添加编辑角色
export const addEditRole = (params: {
  roleCode: string // 角色编码
  roleName: string // 角色名称
  roleDesc: string // 角色描述
  tenantId: number | string | null // 所属客户
  roleId?: number | string | null // 角色id，编辑时必填
}): Promise<ResponseData<void>> => {
  return request.post('/role/add', params)
}

// 删除角色
export const deleteRole = (params: {
  roleId: string // 角色id
}): Promise<ResponseData<void>> => {
  return request.post(`/role/delete?roleId=${params.roleId}`)
}

// 查询角色菜单权限
export const queryRoleMenuPermission = (params: {
  roleId: string
}): Promise<ResponseData<Types.RoleMenuPermission>> => {
  return request.get(`/role/menuPermission`, { params })
}

// 更新角色菜单权限
export const updateRoleMenuPermission = (params: {
  roleId: string
  menuIdList: string[]
}): Promise<ResponseData<void>> => {
  return request.post('/role/editRoleMenuMap', params)
}

// 获取用户菜单权限列表
export const queryUserMenuPermission = (): Promise<ResponseData<Types.UserMenuPermission>> => {
  return request.get(`/role/loginQueryPermission`)
}
